import React, { useEffect, useState, useContext } from 'react';
import { AppContext, FormBuilder } from 'commons-ui';
import { useLocation } from 'react-router-dom';
import useEdit from './useEdit';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validationSchema } from '../../utils/formConfig';
import useService from '../../utils/useService';
import { formatSplashConfig } from '../../utils/formDataParser';

const EditConfigUpdate: React.FC<{}> = () => {
	const { showLoader, handleFormSubmit, handleFormCancel, setShowLoader } = useEdit();
	const { getKeyValueV2 } = useService();
	const [transformedData, setTransformedData] = useState<{ configs: any[] }>({ configs: [] });
	const location = useLocation();
	const { showAlert } = useContext(AppContext);
	const deviceType = location.state?.deviceType;

	useEffect(() => {
		const fetchData = async () => {
			try {
				setShowLoader(true);
				const response = await getKeyValueV2();

				if (!response.data || !Array.isArray(response.data)) {
					return;
				}

				// Filter configurations by device type
				const filteredData = {
					...response,
					data: response.data.filter((item: any) => item.deviceType === deviceType)
				};

				const formattedData = formatSplashConfig(filteredData);
				setTransformedData(formattedData);
			} catch (error) {
				showAlert(`Failed to edit config: ${'Unknown error'}`, { type: 'error' });
			} finally {
				setShowLoader(false);
			}
		};

		fetchData();
	}, [getKeyValueV2, setShowLoader, deviceType]);

	if (!transformedData.configs.length) {
		return <div>Loading...</div>;
	}

	return (
		<FormBuilder
			key={transformedData.configs.length}
			data={transformedData}
			mode='edit'
			showLoader={showLoader}
			handleFormSubmit={handleFormSubmit}
			handleFormCancel={handleFormCancel}
			validationSchema={validationSchema}
			setShowLoader={setShowLoader}
			fieldConfig={FORM_FIELD_CONFIG}
			layoutConfig={FORM_LAYOUT_CONFIG}
		/>
	);
};

export default EditConfigUpdate;
